import {postRequest, getRequest, putRequest, deleteRequest} from './networkService';
import {getContext} from "./context.js";
import {getCachedOrganisation, setCachedOrganisation} from "./cacheService.js";

export async function CreateOrganisation(name) {
    let response = await postRequest('organisations', {name: name});

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error('Failed to create organisation');
    }
}

export async function GetOrganisations() {
    let fakeContext = {
        organisationId: 'any'
    };
    let response = await getRequest('organisations', fakeContext);

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error('Failed to get organisations');
    }
}

export async function GetOrganisation(context) {
    // Try to get from cache first
    const cached = getCachedOrganisation(context.organisationId);
    if (cached) {
        return cached;
    }

    // If not in cache, fetch from API
    let response = await getRequest(`${context.organisationId}/organisations/details`);

    if (response.ok) {
        const data = await response.json();
        // Store in cache
        setCachedOrganisation(context.organisationId, data);
        return data;
    } else {
        throw new Error('Failed to get organisation');
    }
}

export async function DeleteOrganisation(context) {
    let response = await deleteRequest(
        `organisations`,
        {
            id: context.organisationId
        }
    );

    if (!response.ok) {
        throw new Error('Failed to delete organisation');
    }
}